import { render } from "./FormLavado.vue?vue&type=template&id=1a7d7e36"
import script from "./FormLavado.vue?vue&type=script&lang=js"
export * from "./FormLavado.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__